export const CompactingIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path
                fill="currentColor"
                d="M20.54 5.23l-1.39-1.68A2 2 0 0 0 17.63 3H6.36c-.56
                0-1.14.24-1.53.55L3.46 5.23C3.16 5.54 3 5.97 3 6.4V19c0
                1.11.89 2 2 2h14c1.11 0 2-.89 2-2V6.4c0-.43-.16-.86-.46-1.17M12
                17.5L6.5 12H10v-2h4v2h3.5zM5.12 5l.81-1h12.14l.94 1z"
            />
        </svg>
    );
};
